import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox,
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import * as MobileActions from '../../actions';

/* dev
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fstatistics%2Fpurchase%2FmonthlyReport%2Flist&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/
const Config = {
  apiPath: '/statistical/monthlyReport/list',
  detailLink: '/mp/statistics/purchase/monthlyReport',
};

class ManagerialReportList extends Component {
  constructor(props) {
    super(props);
    this.reset = false;
    this.companyCode = '';
    this.pageNum = 1;
    this.searchKey = '';
    this.total = 0;
    this.config = Config;
    this.handleCompanyChange = this.handleCompanyChange.bind(this);
    this.resolveLoading = () => {}; //引用InfiniteLoader中resolveLoading方法，用于重置列表加载状态
    this.count = [];
    this.state = {
      inited: false,
      error: null,
      dataError: null,
      list: [],
      showLoading: true,
      isShowSearch: false,
      unitNum: {},
    };
  }

  init() {
    User.init().then(response => {
      if (response.success) {
        this.setState({
          inited: true,
        });
        this.companyCode = User.getCompanyCode();
        this.getList();
      } else {
        this.setState({
          error: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {}

  getList(cb = () => {}) {
    let postbody = {
      apiPath: this.config.apiPath,
      companyCode: this.companyCode,
      pageNum: this.pageNum,
      pageSize: 10,
      searchKey: this.searchKey,
    };
    let arrPromise = [Http.post('/api/cloudCenter', postbody)];
    this.setState({
      dataError: null,
    });
    Promise.all(arrPromise).then(arrResponse => {
      let response = arrResponse[0];
      this.reset = false;
      this.setState({
        showLoading: false,
      });
      if (response.success) {
        this.setState(
          {
            list: this.state.list.concat(response.data.list),
          },
          () => cb()
        );
        this.pageNum += 1;
        this.total = response.data.total;
      } else {
        this.setState({
          dataError: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  handleCompanyChange(companyCode) {
    this.companyCode = companyCode;
    this.setState({
      showLoading: true,
    });
    this.handleReset();
  }

  handleReset() {
    this.reset = true;
    this.setState({
      list: [],
    });
    this.pageNum = 1;
    this.setState({
      showLoading: true,
    });
    this.getList();
    this.resolveLoading();
  }

  search(text) {
    this.searchKey = text;
    this.setState({
      showLoading: true,
    });
    this.getList();
  }

  render() {
    if (this.state.error !== null) {
      return <Msg {...this.state.error} />;
    }
    return (
      <Page
        transition={false}
        ptr={false}
        onLoadMore={(resolveLoading, finish) => {
          this.resolveLoading = resolveLoading;
          if (this.state.list.length >= this.total) {
            finish();
          } else {
            this.getList(resolveLoading);
          }
        }}
      >
        <Panel>
          {this.state.dataError !== null ? (
            <Msg {...this.state.dataError} />
          ) : (
            <span>
              <div className="list-total">{this.total}</div>
              <PanelBody>
                {this.state.list.map((item, index) => (
                  <Link
                    to={`${this.config.detailLink}/${item.companyCode}/${item.reportXkUniqueCode}`}
                    key={item.id}
                    className="m-list-item"
                  >
                    <MediaBox>
                      <h4>
                        <span className="list-index">{index + 1}</span>
                        {item.companyName}
                      </h4>
                      <ul>
                        <li>
                          <label>报表日期：</label>
                          {formatDate(item.reportDate)}
                        </li>
                      </ul>
                    </MediaBox>
                  </Link>
                ))}
                {!this.state.showLoading && this.state.list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </PanelBody>
            </span>
          )}
        </Panel>
        <Toast icon="loading" show={this.state.showLoading}>
          数据加载中...
        </Toast>
      </Page>
    );
  }
}

ManagerialReportList.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManagerialReportList);
